import axios from 'axios'
import Icon from './components/Icon'

const install = (Vue, options = {}) => {
  const spritesUrl = options.sprites || '/sprites.svg'
  let installed = false

  Vue.component('icon', Icon)

  Vue.mixin({
    created () {
      if (!installed && typeof document !== 'undefined') {
        installed = true
        axios.get(spritesUrl)
          .then(({data}) => {
            const div = document.createElement("div")
            div.style.display = "none"
            div.innerHTML = data

              document.body.appendChild(div)
            })
      }
    }
  })
}

export default {install}
